import React from "react";
import Utility from "../utilities/Utility";
import Input from "./Input";
import Switch from "./Switch";

export default class CallEncryption extends React.Component {
    /**
     * Global exception handling
     * @module ErrorHandling
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state ={
            callEncryptionobj: this.props.callEncryption ? this.props.callEncryption : this.initDataModel(),
            enabled: this.props.callEncryption ? this.props.callEncryption.enabled : false,
            pubKeyNameProperty: this.props.callEncryption ? this.props.callEncryption.pubKeyNameProperty : null,
            pubKeyUrlProperty: this.props.callEncryption ? this.props.callEncryption.pubKeyUrlProperty : null
        }
        this.handleEnabled = this.handleEnabled.bind(this); 
    }

    initDataModel() {

        const callEncryption = {
            id: Utility.uuid4(),
            type: "callEncryption",
            config: "Full Call Encryption",
            enabled: false,
            pubKeyNameProperty: null,
            pubKeyUrlProperty: null,
            recordSensitiveUtterances: false,
            lastLocalChange: window.apm.timestamp
  
        };
        return callEncryption;
    }

    setConfig(key, value = false) {
        // everytime call encryp is off su should be on
        const callEncryption = this.state.callEncryptionobj;
        
        callEncryption[key] = value;
        this.setState({ callEncryptionobj: callEncryption, [key]: value });
        if (key === 'enabled' && value === false && this.props.callEncryption['recordSensitiveUtterances'] === true) {
            callEncryption['recordSensitiveUtterances'] = false;
            this.setState({callEncryptionobj: callEncryption,['recordSensitiveUtterances']:false});
        }
        this.setState({ callEncryptionobj: callEncryption });
       
        // updates app properties
        if(!this.state.callEncryptionobj.lastLocalChange){
            this.state.callEncryptionobj.lastLocalChange = window.apm.timestamp;
        }
        window.apm.setAppProperty(this.state.callEncryptionobj);
        window.apm.setSerializedChanged();
    }

    handleEnabled(){
        const enabled = this.state.callEncryptionobj['enabled'];
        
        if(!enabled){
            document.dispatchEvent(new CustomEvent("ev-update-recordings-for-sensitive", {detail: {val: true}}));
        }
        
    }

    getConfig(key) {
        const callEncryption = this.state.callEncryptionobj;
        return callEncryption[key];
    }
    
    render() {

        return (
            <div className="row">
                <div className="col-md-3">
                    <br />
                    <Switch 
                        context={this} 
                        valKey={"enabled"} 
                        label={"Full Call Encryption"} 
                        tooltip="Enables encryption for the entire call"
                        checked={this.state.enabled ? this.state.enabled : false} 
                        callback={this.handleEnabled}
                    />
                
                </div>
                <div className="col-md-4">
                    <Input 
                        label={"Public Key Name"}
                        tooltip={"Specify public key name used for encryption. Important! Only use App Property name, not its value."}
                        context={this} 
                        valKey={"pubKeyNameProperty"} 
                        value={this.state.pubKeyNameProperty} 
                        disabled={!this.state.enabled}
                        key={"pubKeyNameProperty"+this.state.enabled}
                        valRules= {this.state.enabled ? {"noEmpty": true} : {"noEmpty": false}}
                    />
                </div>
                <div className="col-md-4">
                    <Input 
                        label={"Public Key URL"}
                        tooltip={"Specify public key url used for encryption. Important! Only use App Property name, not its value."}
                        context={this} 
                        valKey={"pubKeyUrlProperty"} 
                        value={this.state.pubKeyUrlProperty}
                        disabled={!this.state.enabled} 
                        key={"pubKeyUrlProperty"+this.state.enabled}
                        valRules= {this.state.enabled ? {"noEmpty": true} : {"noEmpty": false}}
                    />
                </div>
                
                <div className="col-md-6">
                <Switch 
                        context={this} 
                        valKey={"recordSensitiveUtterances"} 
                        label={" Record Sensitive Utterances"} 
                        tooltip="De-select Record Sensitive Utterances to prevent sensitive information like credit card numbers from being recorded."
                        disabled={this.state.enabled ? !this.state.enabled : true} 
                        checked={this.state.callEncryptionobj['recordSensitiveUtterances']} 
                    />
                </div>
                </div>
           
        );
    }
}